import React, { PureComponent } from 'react'
import ImportanceHearts from './importance-hearts'
import StatementStatBarWithDistribution from './statement-stat-bar-with-distribution'
import ThemeBadge from './theme-badge'
import { map } from 'lodash-es'
import DriverStatBar from './driver-stat-bar'
import styled from 'styled-components'
import RespondentGroups from './respondent-groups'

class DriverStat extends PureComponent {

  state = {
    statementsShown: false,
  };

  renderQuestionStat = (questionStats, index, showDistribution) => {
    const { result, rate, skipped, participants, title, respondentGroups } = questionStats;
    const {
      surveyId,
      questionnaire: {
        isAfterGameGuest,
        canViewAfterGame,
      },
      useTranslate,
      filters
    } = this.props;

    return (
      <div key={index} className="d-flex flex-column pt-0 pb-0 mt-1">
        <div className="w-100 mb-2">
          <div className="question driver driver--details mt-3 mb-0">
            <div className="statement-stat-header-row">
              <span className="statement__title">{title}</span>
              <div className="importance-rating d-flex align-items-center">
                <label className="mr-2">{useTranslate("data_vault.importance")}: </label>
                <ImportanceHearts importance={rate} />
                <span className="ml-2">{rate && rate.toFixed(1)}</span>
              </div>
            </div>
            <StatementStatBarWithDistribution
              surveyId={surveyId}
              showDistribution={showDistribution}
              filters={filters}
              questionId={questionStats.id}
              result={result}
              useTranslate={useTranslate}
              size={"sm"}
            />
            {(canViewAfterGame || isAfterGameGuest) && 
              <div className="d-flex align-items-center statement-details-row">
                {(skipped > 0) &&
                  <div className="statement-dncm-amount">
                    {useTranslate("data_vault.does_not_concern")}:  <span>{skipped}/{participants}</span>
                  </div>
                }
                {respondentGroups && <RespondentGroups items={respondentGroups} useTranslate={useTranslate} />}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      index,
      driverStats,
      driverTitle,
      driverDescription,
      theme,
      questions,
      useTranslate,
      sortBy,
      ascending,
      showThemeBadge = true,
      showDistribution = true
    } = this.props

    const { statementsShown } = this.state;
    const { result, rate } = driverStats;
    const sortedStatements = [...questions];
    sortedStatements.sort(sortBy(ascending));

    return (
      <div className="driver driver--details mt-3 mb-2" key={index}>
        {showThemeBadge &&
          <div className="theme-badges">
            <ThemeBadge
              themeTitle={theme.title}
              themeIndex={theme.surveyThemeIndex}
            />
          </div>
        }
        <div className="driver-stat-header-row">
          <div className="driver__title">{driverTitle}</div>
          <div className="importance-rating d-flex align-items-center">
            <label className="mb-0 mr-2">
              {useTranslate("data_vault.importance")}:{" "}
            </label>
            <ImportanceHearts importance={rate} />
            <span className="ml-2">{(rate && rate !== 0) ? rate.toFixed(1) : ''}</span>
          </div>
        </div>
        <div className="driver-statements-container">
          <DriverStatBar result={result} useTranslate={useTranslate} />
          <div
            className="driver__button hover"
            onClick={() => this.setState({ statementsShown: !statementsShown })}
          >
            {statementsShown ? useTranslate("data_vault.close_statements") : useTranslate("data_vault.open_statements")}
          </div>
        </div>
        {statementsShown && (
          <StatementsContainer>
            <div className="driver-description">
              {driverDescription}
            </div>
            <div className="statements">
              {map(sortedStatements, (question, index) =>
                this.renderQuestionStat(question, index, showDistribution)
              )}
            </div>
          </StatementsContainer>
        )}
      </div>
    );
  }
}

export default DriverStat

const StatementsContainer = styled.div`
  border: 1px solid #E6E9EF;
  border-radius: 10px;
  background-color: #fefefe;
  margin-top: 15px;

  .statements {
    padding: 15px;
  }

  .driver-description {
    background-color: #F6F6F5;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid #E6E9EF;
    border-radius: 10px 10px 0 0;
    font-weight: 500;
  }
  
  @media (min-width: 768px) {
    margin-top: 1.5rem;

    .driver-description {
      padding: 1.5rem 1.75rem;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/ui/driver-stat.js